import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Witty extends Modifier {
  static readonly baseTitle = 'Witty';
  static readonly baseText = 'Increases reroll count by 1. Stable.';
  static readonly baseIcon = 'brain';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Witty.baseTitle;
  text = Witty.baseText;
  icon = Witty.baseIcon;
  tags: Array<ModifierTags> = [...Witty.baseTags];
  priority = Witty.basePriority;

  update(stacks: number, params: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: Array<any>;
    rerollMax: number;
    activePlayer: any;
    inactivePlayer: any;
  }) {
    rerollMax += 1;

    const focus = this.owner.statusEffects.find((modifier) => modifier.type === StatusEffect.Focus);
    if (!focus) {
      this.delay = false;
    }

    return { dice, rerollMax, activePlayer, inactivePlayer };
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Witty, Witty);
